import PropTypes from "prop-types";
import React from "react";
import {useDispatch} from "react-redux";

import * as Yup from "yup";
import {useFormik} from "formik";
import withRouter from "components/Common/withRouter";


import {postTeam} from "../../store/actions";

import {Button, Card, CardBody, CardTitle, Col, Container, Form, Input, Label, Row,} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const AddTeam = props => {

  //meta title
  document.title = "Add Service | Temperstack";

  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this  flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {},
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Team Name"),
    }),
    onSubmit: (values) => {
      dispatch(postTeam(values, props.router.navigate));
    }
  });

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title="Temperstack" breadcrumbItem="Add Team"/>

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <CardTitle>Fill all information below</CardTitle>

                  <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <Row>
                      <Col sm="12">
                        <div className="mb-3">
                          <Label htmlFor="name">Team Name</Label>
                          <Input
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            onChange={validation.handleChange}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className="d-flex flex-wrap gap-2">
                      <Button type="submit" color="primary" className="btn ">
                        Save Changes
                      </Button>
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default withRouter(AddTeam);

AddTeam.propTypes = {
  history: PropTypes.object,
};

